import set from 'lodash/set';

import { emptyObject } from 'Lib/constants/placeholder';
import { createAction } from 'Lib/reduxUtils';

import { MATCHES_ENTITY_KEY } from 'Store/entities/entityKeys';
import { Message } from 'Store/entities/types';

import {
  CANCEL_UPDATES_ROOT_SAGA,
  FETCH_INITIAL_MATCHES,
  FETCH_INITIAL_MATCHES_SUCCESS,
  FETCH_MATCH,
  FETCH_MATCH_FAILURE,
  FETCH_MATCH_MESSAGES,
  FETCH_MATCH_MESSAGES_SUCCESS,
  FETCH_MATCH_SUCCESS,
  FETCH_MATCHES,
  FETCH_MATCHES_SUCCESS,
  FETCH_UPDATES,
  FETCH_UPDATES_SUCCESS,
  GET_UPDATES_DATA,
  POLL_UPDATES_DATA,
  SHOW_NEW_MATCH_AND_MESSAGE_NOTIFICATIONS,
  START_UPDATES_ROOT_SAGA,
} from './constants';
import { Entities, MatchFilter } from './types';

export const getUpdatesData = createAction(
  GET_UPDATES_DATA,
  ({ isNudge = false }: { isNudge?: boolean } = emptyObject) => ({
    isNudge,
  })
);
export const pollUpdatesData = createAction(POLL_UPDATES_DATA);
export const startUpdatesRootSaga = createAction(START_UPDATES_ROOT_SAGA);
export const cancelUpdatesRootSaga = createAction(CANCEL_UPDATES_ROOT_SAGA);

export const fetchInitialMatches = createAction(FETCH_INITIAL_MATCHES);
export const fetchInitialMatchesSuccess = createAction(
  FETCH_INITIAL_MATCHES_SUCCESS,
  (data: any, filter: MatchFilter) => ({
    filter,
    ...data,
  })
);

export const fetchMatches = createAction(
  FETCH_MATCHES,
  (listId: string, callback: (payload?: any) => void) => ({
    listId,
    callback,
  })
);
export const fetchMatchesSuccess = createAction(
  FETCH_MATCHES_SUCCESS,
  (data: any, filter: MatchFilter) => ({
    filter,
    ...data,
  })
);

export const fetchMatch = createAction(FETCH_MATCH, (matchId: string) => ({ matchId }));
export const fetchMatchSuccess = createAction(
  FETCH_MATCH_SUCCESS,
  (data: any, matchId: string) => ({
    matchId,
    ...data,
  })
);
export const fetchMatchFailure = createAction(FETCH_MATCH_FAILURE);

export const fetchMatchMessages = createAction(
  FETCH_MATCH_MESSAGES,
  (listId: string, callback: (payload?: any) => void) => ({
    listId,
    callback,
  })
);

export const fetchMatchMessagesSuccess = createAction(
  FETCH_MATCH_MESSAGES_SUCCESS,
  (data: { result?: { messages: Message[]; next_page_token?: string } }, matchId: string) => {
    const { result } = data;
    const { messages } = result || {};
    // update matches
    if (messages?.length) {
      set(data, ['entities', MATCHES_ENTITY_KEY, matchId, 'messages'], [...messages.reverse()]);
    }

    return {
      matchId,
      ...data,
    };
  }
);

export const fetchUpdates = createAction(
  FETCH_UPDATES,
  ({ isNudge = false }: { isNudge?: boolean } = emptyObject) => ({
    isNudge,
  })
);

export const fetchUpdatesSuccess = createAction(
  FETCH_UPDATES_SUCCESS,
  (data: { entities: Entities; result: any }, userId?: string, currentPath?: string) => ({
    userId,
    currentPath,
    ...data,
  })
);

export const showNewMatchAndMessageNotifications = createAction(
  SHOW_NEW_MATCH_AND_MESSAGE_NOTIFICATIONS,
  (type: string, matchId: string, route: string) => ({
    type,
    matchId,
    route,
  })
);
